export const METRIC_MODAL_HEIGHTS = {
  BODY: 600,
  TABLE: 376, // body -24 = no scrolling on right hand panel
};
